(() => {
    angular
        .module('upgradeModule', ['ngAnimate', 'journey.canvas.srv'])
        .controller('upgradeCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache) => {
            $scope.upgradePlan = false;
            $scope.isMasterAccount = helpers.readCookie('isMasterAccount') === '1'

            $rootScope.$watch('translate', (func) => {
                if(func) {
                    $scope.translate = func;
                }
            });

            $scope.closeUpgrade = () => {
                Intercom('trackEvent', 'AP Upgrade Cancel');
                $scope.upgradePlan = false
            };

            $rootScope.$on('upgrade', () => {
                $scope.upgradePlan = true
            });

            if(window.location.search === '?showExpire=true') {
                $scope.expirePlan = true;
            }

            $scope.goUpgrade = () => {
                Intercom('trackEvent', 'apro modal upsell - button');
                FS.event('apro modal upsell - button');
                window.location.href = 'https://app.benchmarkemail.com/process/upgradeemail?upg=aProCanvas'
            }

            $scope.closeExp = () => {
                $scope.expirePlan = false
            };

            $rootScope.$on('expire', () => {
                $scope.expirePlan = true
            });

        }]);
})();


// WEBPACK FOOTER //
// ./app/controllers/upgradeController.js